import { SDT, SearchApi, SearchState } from "./types"

export const initApi = (state_: SearchState, setState_: SDT): SearchApi => {

  const setState = setState_

  const setIsEnabled = (isEnabled: boolean): void => {
    setState_((state) => ({
      ...state,
      isEnabled,
    }))
  }

  const getValue = (): string => (state_.value)

  const setValue = (value: string): void => {
    setState_((state) => ({
      ...state,
      value,
    }))
  }

  const resetValue = (): void => {
    setState_((state) => ({
      ...state,
      value: "",
    }))
  }

  return {
    setState,
    setIsEnabled,
    getValue,
    setValue,
    resetValue,
  }
}
